import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: "include" };

/** Kullanıcı destek rozeti için özet (personelin yanıtladığı, okunmayı bekleyen talep sayısı). */
export const getTicketSummary = async () => {
    const res = await fetch(API.tickets_summary, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Destek talebi özeti alınamadı");
    return res.json();
};

// ─── SUPER_ADMIN ─────────────────────────────────────────────

/** Destek yönetimi rozeti için özet sayaçlar (personel yanıtı bekleyen talep sayısı). */
export const getAdminTicketSummary = async () => {
    const res = await fetch(API.admin_tickets_summary, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Destek talebi özeti alınamadı");
    return res.json();
};
